// import { Outlet } from "react-router-dom";
// import Header from "../components/Elements/Header";
// import SideBar from "../components/Sidebar";
// import Loader from "../components/Elements/Loader";
// import { useSelector } from "react-redux";
// import PopupCard from "../components/Cards/PopupCard/PopupCard";
// import { useEffect, useState } from "react";

// function AdminRoutes() {
//   const loading = useSelector((state) => state.loading.loading);
//   const [popup, setPopup] = useState({
//     open: false,
//     type: "",
//     title: "",
//     message: "",
//   });

//   useEffect(() => {
//     const storedPopup = localStorage.getItem("postLoginPopup");
//     if (storedPopup) {
//       const parsedPopup = JSON.parse(storedPopup);
//       setPopup({ ...parsedPopup, open: true });
//       localStorage.removeItem("postLoginPopup");
//     }
//   }, []);

//   useEffect(() => {
//     if (popup.open === true) {
//       const timer = setTimeout(() => {
//         setPopup((prev) => ({ ...prev, open: false }));
//       }, 2000);
//       return () => clearTimeout(timer);
//     }
//   }, [popup.open]);

//   return (
//     <div className="flex   bg-white w-full">
//       <SideBar />

//       <div className="flex-grow">
//         <div
//           style={{
//             boxShadow: "41px 12px 23.2px 0px rgba(48, 183, 146, 0.12)",
//             zIndex: 10,
//             position: "relative",
//             backgroundColor: "#fff",
//           }}
//         >
//           <Header />
//         </div>
//         <div className="relative">
//           <Loader loading={loading} text="Loading, please wait..." />
//           {!popup.open && <Outlet />}
//         </div>
//       </div>
//       {popup.open && (
//         <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
//           <PopupCard
//             type={popup.type}
//             title={popup.title}
//             message={popup.message}
//           />
//         </div>
//       )}
//     </div>
//   );
// }
// export default AdminRoutes;

import { Outlet } from "react-router-dom";
import Header from "../components/Elements/Header";
import SideBar from "../components/Sidebar";
import Loader from "../components/Elements/Loader";
import { useSelector } from "react-redux";
import PopupCard from "../components/Cards/PopupCard/PopupCard";
import { useEffect, useState } from "react";

function AdminRoutes() {
  const loading = useSelector((state) => state.loading.loading);
  const [popup, setPopup] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });

  useEffect(() => {
    const storedPopup = localStorage.getItem("postLoginPopup");
    if (storedPopup) {
      const parsedPopup = JSON.parse(storedPopup);
      setPopup({ ...parsedPopup, open: true });
      localStorage.removeItem("postLoginPopup");
    }
  }, []);

  useEffect(() => {
    if (popup.open === true) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popup.open]);

  return (
    <div className="min-h-screen bg-gray-50">
      <SideBar />

      <div className="ml-[280px]">
        <Header sidebarWidth={280} />

        <main className="pt-[88px] pb-6">
          <Loader loading={loading} text="Loading, please wait..." />
          {!popup.open && <Outlet />}
        </main>
      </div>

      {popup.open && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
            autoClose
            autoCloseMs={2000}
            onClose={() => setPopup((prev) => ({ ...prev, open: false }))}
          />
        </div>
      )}
    </div>
  );
}

export default AdminRoutes;
